module.exports = __webpack_public_path__ + "7746890983861c64d5accffc7f60097c.png";


//////////////////
// WEBPACK FOOTER
// ./app/pages/HomePage2/Features/shirts.png
// module id = 858
// module chunks = 1